// function safeMoney(cents) {
//   try {
//     const value = Number(cents);
//     if (isNaN(value)) return "0,00";

//     const v = value / 100;

//     // Get current active currency
//     const curr = window.Shopify?.currency?.active || "USD";
//   // console.log("Currency symbol:", currencySymbol); // e.g., "€" or "$"

//     // DKK special formatting
//     if (curr === "DKK") return v.toFixed(2).replace(".", ",") + " kr";

//     // General formatting
//     // You can customize decimal / thousands separator per currency if needed
//     return currencySymbol + " " + v.toFixed(2) ;
//   } catch (e) {
//     return (Number(cents) / 100).toFixed(2);
//   }
// }

function safeMoney(cents) {
  try {
    const value = Number(cents);
    if (isNaN(value)) return "0.00 kr";

    const v = value / 100;

    // Get current active currency
    const curr = window.Shopify?.currency?.active || "USD";

    // DKK special formatting in US style
    if (curr === "DKK") {
      // Convert to string with 2 decimals
      let parts = v.toFixed(2).split(".");
      // Add thousands separator
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts.join(".") + " kr"; 
    }

    // General formatting for other currencies
    let parts = v.toFixed(2).split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".") + " " + curr; 
  } catch (e) {
    return (Number(cents) / 100).toFixed(2) + " kr";
  }
}

class SideCartItem extends HTMLElement {
  constructor() {
    super();

    this.variant_id = this.getAttribute("variant-id");
    this.itemCount = Number(this.getAttribute("item-count"));

    this.sideCart = this.closest("side-cart");

    this.querySelector(".side-cart-item__remove").addEventListener(
      "click",
      this.clearLineItem.bind(this)
    );
    this.querySelectorAll(".side-cart-item__qty-btn")[0].addEventListener(
      "click",
      this.minusQty.bind(this)
    );
    this.querySelectorAll(".side-cart-item__qty-btn")[1].addEventListener(
      "click",
      this.addQty.bind(this)
    );
  }

  updateCart(updates) {
    fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates }),
    })
      .then((response) => response.json())
      .then((cart) => {
        this.sideCart.cart = cart;
        this.sideCart.buildCart(cart, false); // don’t auto-open on qty update
      });
  }

  addQty() {
    let updates = {};
    updates[this.variant_id] = this.itemCount + 1;
    this.sideCart.classList.remove("loaded");
    this.updateCart(updates);
  }

  minusQty() {
    let updates = {};
    updates[this.variant_id] = this.itemCount - 1;
    this.sideCart.classList.remove("loaded");
    this.updateCart(updates);
  }

  clearLineItem() {
    let updates = {};
    updates[this.variant_id] = 0;
    this.sideCart.classList.remove("loaded");
    this.updateCart(updates);
  }
}
customElements.define("side-cart-item", SideCartItem);

class SideCart extends HTMLElement {
  constructor() {
    super();

    this.drawer = this.closest("sidebar-drawer");
    this.itemTemplate = this.querySelector("template#side-cart-item");
  }

  renderSideCartItem(context = {}) {
  const template = this.itemTemplate;
  const clone = template.content.cloneNode(true);
  const element = clone.querySelector("side-cart-item");

  const item = context.item;
  element.setAttribute("variant-id", item.id);
  element.setAttribute("item-count", item.quantity);

  // product url generate karo
  const productUrl = item.url
    ? item.url
    : `/products/${item.handle}`;
      
  element.innerHTML = element.innerHTML
    .replace(
      /\$\$IMAGE_URL\$\$/g,
      item.featured_image?.url
        ? item.featured_image.url + "&width=100"
        : "https://via.placeholder.com/150"
    )
    .replace(/\$\$IMAGE_ALT\$\$/g, item.featured_image?.alt || "")
    .replace(/\$\$ITEM_TITLE\$\$/g, item.product_title)
    .replace(/\$\$ITEM_PRICE\$\$/g, safeMoney(item.final_line_price))
    .replace(
      /\$\$ITEM_CMP_PRICE\$\$/g,
      item.original_price > item.final_price
        ? safeMoney(item.original_price * item.quantity)
        : ""
    )
    .replace(/\$\$ITEM_QUANTITY\$\$/g, item.quantity)
    .replace(
      /\$\$ITEM_VARIANT_TITLE\$\$/g,
      item.variant_title ? item.variant_title : ""
    )
    .replace(/\$\$ITEM_URL\$\$/g, productUrl);

  return clone;
}

  getCart() {

    fetch(window.Shopify.routes.root + "cart.js")
      .then((response) => response.json())
      .then((cart) => {
        this.cart = cart;
        console.log('cart',cart);
        this.buildCart(cart, false); // don’t open drawer on page load
      });

  }

  buildCart(cart, shouldOpen = false) {
    const cartItemsContainer = this.querySelector("#cart-items");
    const cartFooter = this.querySelector(".cart-footer");
    const recentlyViewed = this.querySelector("#recently-viewed");
    const relatedProducts = this.querySelector("#related-products");
    const shippingProgress = this.querySelector("#shipping-progress");

    // Reset container
    cartItemsContainer.innerHTML = "";

    if (cart.items.length === 0) {
      if (cartFooter) cartFooter.style.display = "none";
      if (shippingProgress) shippingProgress.style.display = "none";
      if (recentlyViewed) recentlyViewed.style.display = "none";
      if (relatedProducts) relatedProducts.style.display = "none";

      cartItemsContainer.innerHTML = `
        <div class="empty-cart">
          <div class="empty-cart-icon">
            <svg width="80" height="80" viewBox="0 0 24 24" fill="none">
              <path d="M7 4h-2l-2 12h18l-2-12h-2" stroke="#ccc" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <circle cx="9" cy="20" r="1" fill="#ccc"/>
              <circle cx="17" cy="20" r="1" fill="#ccc"/>
            </svg>
          </div>
          <h3>Your cart is empty</h3>
          <p>Looks like you haven’t added anything yet. Start shopping to fill it up!</p>
          <a href="${window.routes?.all_products_collection_url || "/collections/all"}" class="shop-now-btn">Shop Now</a>
        </div>
      `;
    } else {
      if (cartFooter) cartFooter.style.display = "block";
      if (shippingProgress) shippingProgress.style.display = "block";
      if (recentlyViewed) recentlyViewed.style.display = "block";
      if (relatedProducts) relatedProducts.style.display = "block"; 

      cart.items.forEach((item) => {
        const fragment = this.renderSideCartItem({ item });
        cartItemsContainer.appendChild(fragment);
      });

      //  Update Subtotal
      const cartSubtotal = this.querySelector("#cart-subtotal");
      if (cartSubtotal) {
        cartSubtotal.textContent = safeMoney(cart.total_price);
      }

    }

    // ✅ Update Header Cart Count
    const headerCartCount = document.querySelector("#headerCartIcon .header-cart-count");
    if (headerCartCount) {
      headerCartCount.textContent = cart.item_count;
    }
    // ✅ Dynamic Shipping Update
    this.updateShipping(cart);

    // ✅ Progress Bar (visual only, optional thresholds)
    this.updateShippingProgress(cart);

    this.classList.add("loaded");
    if (shouldOpen) this.drawer.setAttribute("open", "");
  }

  updateShipping(cart) {
    const shippingChargeEl = document.querySelector('#shipping-charge');
    const grandTotalEl = document.querySelector('#grand-total');

    const threshold = window.cartShippingConfig.threshold; 
    const shippingFee = window.cartShippingConfig.fee;

    let shippingCharge = 0;

    if (cart.total_price >= threshold) {
      shippingCharge = 0;
    } else {
      shippingCharge = shippingFee;
    }

    if (shippingChargeEl) {
       shippingChargeEl.textContent = safeMoney(shippingCharge)
    }

    if (grandTotalEl) {
      grandTotalEl.textContent = safeMoney(cart.total_price + shippingCharge);
    }
  }

updateShippingProgress(cart) {
  const shippingBar = document.querySelector("#shipping-progress");
  const shippingMsg = shippingBar?.querySelector(".shipping-message");
  const shippingFill = shippingBar?.querySelector(".progress-fill");

  if (!shippingBar || !shippingMsg || !shippingFill) return;

  // --- CONFIG ---
  let threshold = window.cartShippingConfig.threshold || 0; 
  let shippingCost = window.cartShippingConfig.shipping || 0;

  // Values are already in cents from theme settings, so use directly

  const total = cart.total_price; // already in cents

  if (total >= threshold) {
    let unlockedText = window.cartShippingConfig.unlockedMsg || "";
    unlockedText = unlockedText.replace(
      "{{threshold}}",
      safeMoney(threshold)
    );
    shippingMsg.textContent = unlockedText;
    shippingFill.style.width = "100%";
    shippingFill.style.backgroundColor = "#4caf50"; // green when unlocked
  } else if (total > 0) {
    const remaining = threshold - total;

    let belowText = window.cartShippingConfig.belowMsg || "";
    belowText = belowText.replace(
      "{{remaining}}",
      safeMoney(remaining)
    );
    belowText = belowText.replace(
      "{{threshold}}",
      safeMoney(threshold)
    );

    shippingMsg.textContent = belowText;

    let progressPercent = (total / threshold) * 100;
    if (progressPercent > 100) progressPercent = 100;
    shippingFill.style.width = progressPercent + "%";

    // Color based on progress
    if (progressPercent < 50) {
      shippingFill.style.backgroundColor = "orange";
    } else {
      shippingFill.style.backgroundColor = "#4caf50";
    }
  } else {
    shippingMsg.textContent = "Add items to unlock Free Shipping!";
    shippingFill.style.width = "0%";
    shippingFill.style.backgroundColor = "orange";
  }
}

  addLineItem(line_item) {
    if (this.cart) {
      line_item.final_line_price = line_item.final_price * line_item.quantity;

      const existingLineItem = this.cart.items.find(
        (item) => item.id == line_item.id
      );
      if (existingLineItem) {
        existingLineItem.quantity = line_item.quantity;
        existingLineItem.final_line_price = line_item.final_line_price;
      } else {
        this.cart.items.push(line_item);
      }

      const accumulate = (items, prop) => {
        return items.reduce((a, b) => a + b[prop], 0);
      };

      this.cart.total_price = accumulate(this.cart.items, "final_line_price");

      this.buildCart(this.cart, true); // ✅ open drawer after adding item
    } else {
      this.getCart();
    }
  }
}
customElements.define("side-cart", SideCart);

document.addEventListener("DOMContentLoaded", function () {
  const sideCart = document.querySelector("side-cart");
  if (sideCart) {
    sideCart.getCart(); // Fetch cart JSON and rebuild UI with correct shipping bar
  }
});
